<div class="topnav" *ngIf="environmentName !== ''">
   <p class="govuk-body para_text">This is the
    <span>{{environmentName}}</span> environment.
   </p> 
  </div>
  
